import { Chip } from "@mui/material";

export const mapCustomerToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

const syncStatusColor = {
  pending: "warning",
  success: "info",
  fail: "error",
};

export const statusOption = [
  {
    id: "active",
    name: "Active",
  },
  {
    id: "block",
    name: "Block",
  },
];

const renderSyncStatus = (syncStatus) => {
  const syncStatusObject = {
    pending: (
      <Chip
        label={syncStatus}
        color={syncStatusColor.pending}
        disabled={false}
        size="small"
        variant="filled"
      />
    ),
    success: (
      <Chip
        label={syncStatus}
        color={syncStatusColor.success}
        disabled={false}
        size="small"
        variant="filled"
      />
    ),
    fail: (
      <Chip
        label={syncStatus}
        color={syncStatusColor.fail}
        disabled={false}
        size="small"
        variant="filled"
      />
    ),
  };

  return syncStatusObject[syncStatus];
};

export const customerColumns = [
  { key: "name", label: "Name", align: "center" },
  {
    key: "syncStatus",
    label: "Sync Status",
    align: "center",
    render: (item) => renderSyncStatus(item.syncStatus),
  },
  { key: "phoneNumber", label: "phone Number", align: "center" },
];
